"use client";
import { useSession } from "next-auth/react";
import { useState } from "react";
import TrackOrder from "./TrackOrder";

const Topbar = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };
  const { data: session } = useSession();

  return (
    <div className="relative gradient-navy text-white">
      <div className="absolute inset-0 bg-brand-sky/10 pointer-events-none" />
      <div className="relative container mx-auto px-4 h-12 flex items-center justify-end gap-3 sm:gap-5">
        <div className="hidden sm:flex items-center gap-2 text-xs sm:text-sm text-white/80">
          <span className="hidden md:inline">Hotline:</span>
          <a
            href="https://wa.me/8801788804446"
            target="_blank"
            rel="noreferrer"
            className="hover:text-brand-sky transition-colors font-medium"
          >
            01788804446
          </a>
        </div>

        <span className="hidden sm:block w-px h-4 bg-white/20" />

        <select
          value={selectedLanguage}
          onChange={handleLanguageChange}
          className="bg-transparent border border-white/20 hover:border-brand-sky rounded-md px-2 py-1 text-xs sm:text-sm text-white focus:outline-none focus:ring-2 focus:ring-brand-sky/40 transition-colors cursor-pointer"
          aria-label="Select language"
        >
          <option value="en" className="text-gray-800">
            English
          </option>
          <option value="bn" className="text-gray-800">
            বাংলা
          </option>
        </select>

        {session?.user?.email && (
          <>
            <span className="hidden sm:block w-px h-4 bg-white/20" />
            <TrackOrder />
          </>
        )}
      </div>
    </div>
  );
};

export default Topbar;